import { animate, style, transition, trigger } from '@angular/animations';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { MediaObserver } from '@angular/flex-layout';
import { ActivatedRoute } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { NUMBER_200 } from '~shared/constants';
import { MEDIA_ALISES } from '~shared/constants/media.constant';
import { Tab } from '../../models';

@Component({
  selector: 'app-storefront-tabs',
  templateUrl: './tabs.component.html',
  styleUrls: ['./tabs.component.scss'],
  animations: [
    trigger('fadeInOut', [
      transition(':enter', [
        style({ opacity: 0, visibility: 'hidden', height: 0 }),
        animate(NUMBER_200, style({ opacity: 1, visibility: 'visible', height: 'auto' })),
      ]),
      transition(':leave', [animate(0, style({ opacity: 0, visibility: 'hidden', height: 0 }))]),
    ]),
  ],
})
export class TabsComponent implements OnInit, OnDestroy {
  @Input() tabs: Tab[];
  activeFragment: string;
  destroySubject = new Subject();
  isMobile: boolean;

  constructor(private readonly route: ActivatedRoute, private readonly mediaObserver: MediaObserver) {
    this.mediaObserver
      .asObservable()
      .pipe(takeUntil(this.destroySubject))
      .subscribe(() => (this.isMobile = this.mediaObserver.isActive(MEDIA_ALISES.mobile)));
  }

  ngOnInit() {
    this.route.fragment.pipe(takeUntil(this.destroySubject)).subscribe((fragment) => this.setActiveTab(fragment));
  }

  ngOnDestroy() {
    this.destroySubject.next();
  }

  setActiveTab(id?: string) {
    this.activeFragment = this.tabs.some((tab) => tab.fragment === id) ? id : this.tabs[0] && this.tabs[0].fragment;
  }
}
